import styled from 'styled-components';

export const AvoidBreakInside = styled.div`
  @media print {
    break-inside: avoid;
  }
`;
